import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=7b21ce5c&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&lang=js"
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=7b21ce5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b21ce5c",
  null
  
)

export default component.exports